// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Styles.css';


function Footer({ feedbackSearch }) {
    return (
        <section className="footer">
            <div className="footer-container">
                <div className="logo-column">
                    <div className="logo-container">
                        <a href="https://www.villamiabali.com/" target="_blank" rel="noopener noreferrer" aria-label="Villa Mia Website">
                            <div className="logo" role="img" aria-label="Villa Mia Logo"></div>
                        </a>
                    </div>
                </div>

                <div className="contact-column">
                    <h3 className="get-in-touch">Get In Touch</h3>

                    <div className="contact-item whatsapp">
                        <i className="fab fa-whatsapp"></i>
                        <span>Chat on WhatsApp</span>
                    </div>

                    <div className="contact-item phone">
                        <span>Phone: +62 812-3810-8044</span>
                    </div>

                    <div className="contact-item email">
                        <span>Email: villamiabali1@gmail.com</span>
                    </div>

                    <div className="social-icons" aria-label="Social media links">

                    </div>
                </div>

                <div className="booking-column">
                    {feedbackSearch !== undefined && (
                        <Link
                            to={`/feedback?${feedbackSearch}`}
                            className="booking-link"
                            aria-label="Give us Feedback"
                            onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}
                        >
                            <div className="booking-box feedback-box">
                                GIVE US <br /> FEEDBACK
                            </div>
                        </Link>
                    )}
                    <a
                        href="https://us2.cloudbeds.com/en/reservation/2bkj4m?currency=idr"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Book direct at Cloudbeds"
                        className="booking-link"
                    >
                        <div className="booking-box">
                            CHECK AVAILABILITY & <br /> BOOK DIRECT
                        </div>
                    </a>
                </div>
            </div>
            <div className="terms-and-conditions">
                <p>
                    © 2025 Villa Mia﻿ | All Rights Reserved | Powered by Dsto v1.0.76
                </p>
            </div>
        </section>
    );
}

export default Footer;